import {
  INPUT_CHANGE,
  INPUT_ERROR,
  LOGIN_ERROR,
  LOGIN_REQUEST,
  LOGIN_SUCCESS, LOGOUT_REQUEST,
  LOGOUT_SUCCESS
} from "./login-action-types";

export const inputChange = ({ value, field }) => ({
  type: INPUT_CHANGE,
  value,
  field
});
export const inputError = ({ error, field }) => ({
  type: INPUT_ERROR,
  error,
  field
});

export const loginRequest = history => ({ type: LOGIN_REQUEST, history });
export const loginSuccess = token => ({ type: LOGIN_SUCCESS, token });
export const loginError = error => ({ type: LOGIN_ERROR, error });

export const logoutRequest = history => ({ type: LOGOUT_REQUEST, history });
export const logoutSuccess = () => ({ type: LOGOUT_SUCCESS });



// WEBPACK FOOTER //
// ./src/modules/login/login-action-creators.js